// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox-module__checkbox___moqcA","checkboxInput":"Checkbox-module__checkboxInput___jUdw1","checkboxTick":"Checkbox-module__checkboxTick___YBKjb"};